import React, { Fragment } from 'react';

import '../assets/css/PymeContactBox.scss';

import Bubble from './Bubble';
import BubbleMobile from './BubbleMobile';

const PymeInfoBox = ({ pyme }) => {
  const {
    paymentMethodCash,
    paymentMethodCreditDebitCard,
    paymentMethodTransfers,
    paymentMethodAnother,
    pickup,
    shipingProducts,
  } = pyme;

  return (
    <Fragment>

      <div className="row py-0 my-4 px-0">
        <div className="col-lg-3 p-0">
          <p style={{ fontSize: '18px' }}>
            <strong>Despachos</strong>
          </p>
          <div className="row p-0">
            <div className="col-6 px-0 d-none d-sm-block">
              <Bubble
                condition={shipingProducts === 'Yes' || shipingProducts}
                text="A todo Chile"
              />
            </div>
            <BubbleMobile
            condition={shipingProducts === 'Yes' || shipingProducts}
            text="A todo Chile"
            />
            <div className="col-6 d-none d-sm-block">
              <Bubble
                condition={pickup === 'Yes' ? true : false}
                text="Punto de retiro"
              />
            </div>
            <BubbleMobile
            condition={pickup === 'Yes' ? true : false}
            text="Punto de retiro"
            />
          </div>
        </div>
        <div className="col-lg-2 p-0">
        </div>
        <div className="col-lg-7 p-0">
          <p style={{ fontSize: '18px' }}>
            <strong>Medios de Pagos</strong>
          </p>
          <div className="row p-0">
            <div className="col-3 p-0 d-none d-sm-block">
              <Bubble
                condition={paymentMethodCreditDebitCard}
                text="Tarjetas crédito/débito"
              />
            </div>
            <BubbleMobile
            condition={paymentMethodCreditDebitCard}
            text="Tarjetas crédito/débito"
            />
            <div className="col-3 d-none d-sm-block">
              <Bubble condition={paymentMethodCash} text="Efectivo" />
            </div>
            <BubbleMobile
            condition={paymentMethodCash}
            text="Efectivo"
            />
            <div className="col-3 d-none d-sm-block">
              <Bubble
                condition={paymentMethodTransfers}
                text="Transferencias"
              />
            </div>
            <BubbleMobile
            condition={paymentMethodTransfers}
            text="Transferencias"
            />
            <div className="col-3 d-none d-sm-block">
              <Bubble condition={paymentMethodAnother} text="Otros" />
            </div>
            <BubbleMobile
            condition={paymentMethodAnother}
            text="Otros"
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PymeInfoBox;
